import _404 from 'src/app/404/components/404';

export default [
  {
    path: '/404',
    name: '404',
    component: _404,
  },
];
